import type React from 'react';
import { Section, SectionHeader } from '@/components/ui/Section';
import { HandDrawnX } from '@/components/ui/decorative';

interface Problem {
  readonly label: string;
  readonly body: string;
}

const PROBLEMS: ReadonlyArray<Problem> = [
  {
    label: 'Information Overload',
    body: 'Opening 30+ browser tabs for every single article. Research shouldn’t feel like a digital burial.',
  },
  {
    label: 'Bottlenecked Growth',
    body: 'Junior writers needing 3+ hours of senior editing. Scale your output, not your oversight.',
  },
  {
    label: 'Diluted Authority',
    body: 'Publishing “good enough” when you want “genuinely proud.” Deep research is the only moat.',
  },
];

export const ProblemAgitation: React.FC = () => {
  return (
    <Section className="bg-cream-paper border-b border-aged-brass/20">
      <SectionHeader
        badge="The Problem"
        title="You have the insights. The system steals your time."
        description="Recognition as an industry authority shouldn't cost you family dinners and weekend marathons."
        align="left"
      />

      <div className="relative">
        {/* Decorative oversized "3" background number */}
        <div className="absolute -left-4 -top-12 text-[180px] font-display font-bold text-aged-brass/[0.04] select-none pointer-events-none leading-none hidden md:block">
          3
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 md:divide-x md:divide-aged-brass/20">
          {PROBLEMS.map((problem, index) => (
            <article
              key={problem.label}
              className={`md:px-10 ${index === 0 ? 'md:pl-0' : ''} ${index === PROBLEMS.length - 1 ? 'md:pr-0' : ''} py-8 md:py-2`}
            >
              <HandDrawnX className="w-5 h-5 mb-5 opacity-50" />
              <h3 className="smcp text-[13px] text-bottle-green font-semibold mb-4">
                {problem.label}
              </h3>
              <p className="font-serif text-base md:text-[1.0625rem] text-charcoal leading-relaxed">
                {problem.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </Section>
  );
};
